// @flow

export const FETCH_EMAIL_NOTIFICATIONS = 'EMAIL/FETCH_EMAIL_NOTIFICATIONS';



// WEBPACK FOOTER //
// ./app/NotificationsManager/email/actionTypes.js